var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBestsellerItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#ffae00;stroke-miterlimit:10;stroke-width:1.91px;}")), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12,
    cy: 14.85,
    r: 7.65
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "8.17 8.23 8.17 3.37 15.83 3.37 15.83 8.23"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12,
    y1: 0.5,
    x2: 12,
    y2: 3.37
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "12 11.02 13.26 13.06 15.58 13.62 14.04 15.45 14.21 17.84 12 16.93 9.79 17.84 9.96 15.45 8.42 13.62 10.74 13.06 12 11.02"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestsellerItem);
export default __webpack_public_path__ + "static/media/bestsellerItem.0933b77874682cb2f86eb1dacb21325b.svg";
export { ForwardRef as ReactComponent };